export const getByte = (str) =>
	str
		.split('')
		.map((s) => s.charCodeAt(0))
		/* eslint-disable-next-line */
		.reduce((prev, c) => prev + (c >> 11 ? 3 : c >> 7 ? 2 : 1), 0);

export const hexToRgb = (hex) => {
	const r = parseInt(hex.slice(1, 3), 16);
	const g = parseInt(hex.slice(3, 5), 16);
	const b = parseInt(hex.slice(5, 7), 16);

	return { r, g, b };
};

export const unEscapeAll = (str) => {
	const regex = /&(amp|lt|gt|quot|#39|#40|#41);/g;
	const chars = {
		'&amp;': '&',
		'&lt;': '<',
		'&gt;': '>',
		'&quot;': '"',
		'&#39;': "'",
		'&#40;': '(',
		'&#41;': ')',
	};

	return regex.test(str) ? str.replace(regex, (matched) => chars[matched] || matched) : str;
};
